import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { productTypes } from '../../../../types/products';

import { TranslatedCopy } from '../../../../intl';
import { H1 } from '../../../../components';

import OrderReturnsPageProduct from '../OrderReturnsPageProduct';

const OrderReturnsPageFinalDetails = ({
  products,
  getReturnData,
  returnsForm,
  currencyCode,
  submittableReturnsList
}) => (
  <>
    <div className='prl7-sm prl12-md pt4-sm pb3-sm u-full-width bg-white'>
      <H1>
        <TranslatedCopy id='orderreturns.returnDetails' />
      </H1>
    </div>
    <div className='orderReturns__final flex-container center u-full-width bg-white'>
      <div className='orderReturns__final_details u-full-width'>
        {products && products.length && (
          <>
            {products
              .filter(product =>
                submittableReturnsList.some(
                  submittableReturn =>
                    submittableReturn.productCode === product.productCode && submittableReturn.quantity > 0
                )
              )
              .map(product => (
                <OrderReturnsPageProduct
                  key={product.id}
                  product={product}
                  returnableData={getReturnData(product.productCode)}
                  returnsForm={returnsForm}
                  // overrideTotalQty={parseInt(
                  //     returnsForm.values[`orderReturns__product_returnAmt_${product.productCode}`],
                  //     10
                  // )}
                  currencyCode={currencyCode}
                  embedded
                  displayOnly
                  submittableReturnsList={submittableReturnsList}
                />
              ))}
          </>
        )}
      </div>
    </div>
  </>
);

OrderReturnsPageFinalDetails.propTypes = {
  products: PropTypes.arrayOf(productTypes),
  getReturnData: PropTypes.func.isRequired,
  returnsForm: PropTypes.any,
  currencyCode: PropTypes.string,
  submittableReturnsList: PropTypes.array.isRequired
};

OrderReturnsPageFinalDetails.defaultProps = {
  products: null,
  returnsForm: null,
  currencyCode: null
};

export default OrderReturnsPageFinalDetails;
